import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=229f949a&scoped=true"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"
import style0 from "./AddBanner.vue?vue&type=style&index=0&id=229f949a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f949a",
  null
  
)

export default component.exports